import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { ExemptBusinessListComponent } from "app/components/mainMenu/exemptBusinessList/exemptBusinessList.component";
import { IBusinessView } from "app/models/business/business";
import { IReportSelectItems, ISelectItems } from "app/models/shared/shared";
import { AdminService } from "app/services/admin/admin.service";
import { ProcessComplaintService } from "app/services/complaint/processComplaint.service";


@Component({
  selector: 'processNewBusiness',
  templateUrl: './processNewBusiness.component.html',
  styleUrls: ['./processNewBusiness.component.scss']
})

export class ProcessNewBusinessComponent implements OnInit {

  countyList = this.sharedService.countyDropDownList;
  businessId: string = '';
  complaintId: number = 0;
  businessList: ISelectItems[] = [];
  statusList: IReportSelectItems[] = [];
  nonActionableList: ISelectItems[] = [];
  currentBusinessLocal: IBusinessView = null;
  newBusiness: boolean = false;
  savedBusiness: boolean = false;
  typeOfBusinessList: ISelectItems[] = [];

  businessForm = new UntypedFormGroup({
    businessName: new UntypedFormControl('', [Validators.required]),
    businessType: new UntypedFormControl('', [Validators.required]),
    businessAddress1: new UntypedFormControl('', [Validators.required]),
    businessAddress2: new UntypedFormControl(''),
    businessCity: new UntypedFormControl('', [Validators.required]),
    businessZip: new UntypedFormControl('', [Validators.required]),
    businessPhone: new UntypedFormControl('', [Validators.required]),
    contactName: new UntypedFormControl(''),
    contactTitle: new UntypedFormControl(''),
    contactEmail: new UntypedFormControl('', [Validators.email]),
    businessOwner: new UntypedFormControl(''),
    stateId: new UntypedFormControl({ value: '', disabled: true }),
    countyId: new UntypedFormControl('', [Validators.required]),
    businessPhoneExt: new UntypedFormControl(''),
  });

  public form = new UntypedFormGroup({
    orelapId: new UntypedFormControl('', [Validators.required]),
    labelPosition: new UntypedFormControl('1', [Validators.required])
  });

  constructor(
    private sharedService: SharedService,
    private adminService: AdminService,
    private processComplaintService: ProcessComplaintService,
    private modalService: MatDialog,
    private dialogRef: MatDialogRef<ProcessNewBusinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentBusinessLocal = this.data.business;
    this.setParameters();
  }

  ngOnInit(): void {
    this.businessList = this.sharedService.businessTypeDropDownList;
    this.savedBusiness = false;
    this.typeOfBusinessList = this.sharedService.businessTypeDropDownList;
    let status = false;
    if (this.currentBusinessLocal == null || this.currentBusinessLocal == undefined) {
      this.businessForm.controls['active'].setValue(true);
    }
    else {
      status = this.currentBusinessLocal.exempt
    }
  }

  getBusiness() {
    this.adminService.getNonActionable().subscribe({
      next: response => {
        this.nonActionableList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });
  }

  save() {
    if (this.businessForm.valid) {
      this.setBusinessParam();

      this.processComplaintService.saveNewBusiness(this.currentBusinessLocal).subscribe({
        next: response => {
          this.sharedService.toastr.success("Business Saved");
          this.savedBusiness = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not save New Business Process");
        },
      });
    }
    else{
      this.sharedService.toastr.error("Please fill out all required fields");
    }
  }

  setBusinessParam() {
    let tempForm = this.businessForm.getRawValue();
      this.currentBusinessLocal.businessName = tempForm.businessName;
      this.currentBusinessLocal.businessType = +tempForm.businessType;
      this.currentBusinessLocal.businessAddress1 = tempForm.businessAddress1;
      this.currentBusinessLocal.businessAddress2 = tempForm.businessAddress2;
      this.currentBusinessLocal.businessCity = tempForm.businessCity;
      this.currentBusinessLocal.businessZip = tempForm.businessZip;
      this.currentBusinessLocal.businessPhone = tempForm.businessPhone;
      this.currentBusinessLocal.contactName = tempForm.contactName;
      this.currentBusinessLocal.businessOwnerTitle = tempForm.contactTitle;
      this.currentBusinessLocal.businessOwnerEmail = tempForm.contactEmail;
      this.currentBusinessLocal.businessOwner = tempForm.businessOwner;
      this.currentBusinessLocal.stateId = tempForm.stateId;
      this.currentBusinessLocal.countyId = tempForm.countyId;
      this.currentBusinessLocal.businessPhoneExt = tempForm.businessPhoneExt;
      this.currentBusinessLocal.category = tempForm.businessType;
  }

  setParameters() {
    this.businessForm.controls['businessName'].setValue(this.currentBusinessLocal.businessName);
    if (this.currentBusinessLocal.businessType != 0){
      this.businessForm.controls['businessType'].setValue(this.currentBusinessLocal.businessType.toString());
    }
    this.businessForm.controls['businessAddress1'].setValue(this.currentBusinessLocal.businessAddress1);
    this.businessForm.controls['businessAddress2'].setValue(this.currentBusinessLocal.businessAddress2);
    this.businessForm.controls['businessCity'].setValue(this.currentBusinessLocal.businessCity);
    this.businessForm.controls['businessZip'].setValue(this.currentBusinessLocal.businessZip);
    this.businessForm.controls['businessPhone'].setValue(this.currentBusinessLocal.businessPhone);
    this.businessForm.controls['contactName'].setValue(this.currentBusinessLocal.contactName);
    this.businessForm.controls['contactTitle'].setValue(this.currentBusinessLocal.contactTitle);
    this.businessForm.controls['contactEmail'].setValue(this.currentBusinessLocal.contactEmail);
    this.businessForm.controls['businessOwner'].setValue(this.currentBusinessLocal.businessOwner);
    this.businessForm.controls['stateId'].setValue(this.currentBusinessLocal.stateId);
    this.businessForm.controls['countyId'].setValue(this.currentBusinessLocal.countyId);
    this.businessForm.controls['businessPhoneExt'].setValue(this.currentBusinessLocal.businessPhoneExt);
  }

  return(): void {
    let returnData = this.savedBusiness ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

  showExemptBusinesses() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = true;
    config.minWidth = 600;
    config.maxHeight = 600;
    config.data = {
    };
    const dialogRef = this.modalService.open(ExemptBusinessListComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data > 0) {
          this.dialogRef.close(data);
        }
      },
      error => this.sharedService.toastr.error("Could not preview Correspondence"),
      () => { }
    );
  }

}